import React from 'react'

export default ({
    title,
    copy,
    hashtag
}) => {

    return (
        <div className="container">
            <h2 className={'h1'} dangerouslySetInnerHTML={{__html: title}}/>
            <div className="copy medium" dangerouslySetInnerHTML={{__html: copy}}/>
            { hashtag &&
                <a className={'hashtag'} target="_blank">
                    #{ hashtag }
                </a>
            }
        </div>
    )
}